export default "__VITE_ASSET__D94xM$2D__"